import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { UpdateQuoteData } from "../types";
import { updateQuote } from "../apis/updateQuote";

export const useUpdateQuote = () => {
    const queryClient = useQueryClient();

    return useMutation<ApiResponse, Error, UpdateQuoteData>({
        mutationFn: updateQuote,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
        },
    });
};
